import { Box, Typography, Stack } from '@mui/material';
import { format, parse } from 'date-fns';
import React from 'react';

import { theme } from '@app/theme';
import {
  Product,
  ProductEventAction,
  ProductEventDateType,
  ProductEventName,
} from '@app/types/catalog';

interface EventInfoProps {
  product: Product;
}

export function EventInfo({ product }: EventInfoProps) {
  const rows = [
    {
      label: 'タイトル',
      value: (
        <>
          {
            Object.values(ProductEventName).find(
              (name) => name.key === product.customFields.eventName
            )?.label
          }
          {product.customFields.eventAction &&
            `（${
              Object.values(ProductEventAction).find(
                (action) => action.key === product.customFields.eventAction
              )?.label
            }）`}
        </>
      ),
    },
    {
      label: '日程',
      value: (
        <Typography>
          {
            Object.values(ProductEventDateType).find(
              (type) =>
                type.key === product.customFields.eventDateType &&
                !['fixedDate', 'between'].includes(type.key)
            )?.label
          }
          {product.customFields.eventDateType === 'fixedDate' &&
            // NOTE: 日時指定であれば、eventDateListは必須で設定されているものとする。
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            product.customFields
              .eventDateList!.map((date) =>
                format(parse(date, 'yyyy/MM/dd', new Date()), 'yyyy年MM月dd日')
              )
              .join('／')}
          {product.customFields.eventDateType === 'between' &&
            `${format(
              parse(
                // NOTE: 期間限定であれば、eventDateSinceは必須で設定されているものとする。
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                product.customFields.eventDateSince!,
                'yyyy/MM/dd',
                new Date()
              ),
              'yyyy年MM月dd日'
            )}〜${format(
              parse(
                // NOTE: 期間限定であれば、eventDateUntilは必須で設定されているものとする。
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                product.customFields.eventDateUntil!,
                'yyyy/MM/dd',
                new Date()
              ),
              'yyyy年MM月dd日'
            )}`}
        </Typography>
      ),
    },
    {
      label: '時間',
      value: (
        <Typography>
          {product.customFields.eventTimeSince &&
            product.customFields.eventTimeUntil &&
            `${product.customFields.eventTimeSince.replace(
              ':',
              '時'
            )}分〜${product.customFields.eventTimeUntil.replace(':', '時')}分`}
        </Typography>
      ),
    },
    {
      label: '備考',
      value: product.customFields.eventContent,
    },
  ];

  return (
    <div>
      <Typography
        width="100%"
        bgcolor={theme.palette.blueAccent.main}
        color="white"
        px={2}
        height={36}
        fontWeight={600}
        borderRadius={15}
        display="flex"
        alignItems="center"
        variant="h6"
      >
        イベント情報
      </Typography>
      <Stack spacing={2.5} maxWidth={1040} mx="auto" mt={6} pb={7} width="100%">
        {rows.map(({ label, value }, index) => (
          <Stack
            borderBottom={1}
            borderColor="#E0E0E0"
            key={index}
            direction={{ sm: 'row', xs: 'column' }}
            spacing={1}
            pb={2.5}
          >
            <Typography
              sx={{
                color: '#718CA0',
                fontWeight: 700,
                minWidth: 200,
                whiteSpace: 'nowrap',
              }}
            >
              {label}
            </Typography>
            <Box
              sx={{
                whiteSpace: 'pre-wrap',
              }}
            >
              {value}
            </Box>
          </Stack>
        ))}
      </Stack>
    </div>
  );
}
